import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import styled from 'styled-components'
import {onChangeCheckedHandler} from 'lib/dom'
import React from 'react'
import {EnabledSwitch} from 'lib/ui/form/Switch'

export default function ToggleSponsorsSwitch() {
  const {sponsors} = useTemplate()
  const save = useSaveTemplate()
  const toggle = (isVisible: boolean) => {
    save({
      sponsors: {
        isEnabled: isVisible,
      },
    })
  }

  return (
    <StyledEnabledSwitch
      checked={sponsors.isEnabled}
      onChange={onChangeCheckedHandler(toggle)}
      aria-label="toggle sponsors"
    />
  )
}

const StyledEnabledSwitch = styled(EnabledSwitch)`
  margin-bottom: 0;
`
